<template>
    <div>
    <button class="mt-3 bg-gray-200 border-gray-200 hover:bg-gray-300 text-gray-700 duration-200 px-3 py-2 text-sm font-light rounded" @click="$modal.show('modal-sign-devis')">{{$t('mes_produits.devis.signer')}}</button>
    <modal name="modal-sign-devis">
        <div class="text-black">
            <sav-draw-input :bg="fileUrlImg" id="sign-devis" class="mt-3" />
            <div class="text-center">
                <button :disabled="loading" class="mt-3 bg-green-600 hover:bg-green-700 text-white duration-200 px-3 py-2 text-sm font-light rounded" @click="save">
                    <span v-if="!loading">{{$t('mes_produits.devis.terminer')}}</span>
                    <sav-spinner color="#fff" v-if="loading" />
                </button>
            </div>
        </div>
    </modal>
    </div>
</template>

<script>
import SavDrawInput from '@/components/SavDrawInput.vue'
import eventHub from '@/eventHub'

export default {
    components: {SavDrawInput},
    props: {
        fileUrl: {required: true}
    },
    data() {
        return {
            loading: false,
            fileUrlImg: null,
        }
    },
    methods: {
        save() {
            this.loading = true
            eventHub.$emit('save-draw-sign-devis', {
                type: 'pdf',
                callback: (callback) => {
                    if (callback && callback.data && callback.data.files && callback.data.files.length > 0) {
                        this.signData = callback.data.files[0]
                        this.$modal.hide('modal-sign-devis')
                        this.$emit('end', this.signData)
                    } else {
                        this.loading = false
                        this.$toast.error(this.$t('mes_produits.devis.signature_non_valide'))
                    }
                }
            })
        },
    },
    mounted() {
        this.$PdfTool.convertPdfToBlob(this.fileUrl, async (img) => {
            this.fileUrlImg = URL.createObjectURL(img)
        })
    }   
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/companies/default/views/user/product/FolderActions.vue/components/SignDevis.vue